import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useGetPrivacyPolicyQuery } from '../../apis/cmsApi/cms.hooks.api';
import { BaseLayout } from '../../components/Layout/Layout';
import { useBack } from '../../hooks/useBack';
import { useLanguage } from '../../locale/useLanguage';

type PrivacyPolicyViewProps = {};

export const PrivacyPolicyView: React.FC<PrivacyPolicyViewProps> = () => {
  const languageSettings = useLanguage();
  const t = languageSettings[0];
  const locale = languageSettings[2];
  const back = useBack();

  const { data: privacyPolicy } = useGetPrivacyPolicyQuery({
    locale,
  });

  return (
    <BaseLayout
      title={t('pageTitles.privacy')}
      hasBack
      hasViewportHeight
      onBackClick={back}
    >
      {privacyPolicy && <ReactMarkdown>{privacyPolicy.content}</ReactMarkdown>}
    </BaseLayout>
  );
};
